module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.inArr), function(item, inx) {
    return _c('el-tag', {
      key: item,
      staticClass: "tag-item",
      attrs: {
        "closable": ""
      },
      on: {
        "close": function($event) {
          _vm.tagRemove(inx)
        }
      }
    }, [_vm._v("\n      " + _vm._s(item) + "\n    ")])
  }), _vm._v(" "), (_vm.tagEdit) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "tag-input",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": function($event) {
        _vm.goEdit(2)
      }
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.goEdit(2)
      }
    },
    model: {
      value: (_vm.newTag),
      callback: function($$v) {
        _vm.newTag = $$v
      },
      expression: "newTag"
    }
  }) : _c('el-button', {
    staticClass: "new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.goEdit(1)
      }
    }
  }, [_vm._v("+ 新标签")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-5443445c"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/inCComps/tagSelect.vue
// module id = 1495
// module chunks = 1